module.exports = __webpack_public_path__ + "static/media/galdisa_home.28bc34b9.mp4";